import { render, staticRenderFns } from "./sumo-select.vue?vue&type=template&id=890bb3b8"
import script from "./sumo-select.vue?vue&type=script&lang=js"
export * from "./sumo-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports